<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopCommunity.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopCommunityInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="shopCommunityInfo.conditions.shopName"
                :placeholder="$t('shopCommunity.shopName')"
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="shopCommunityInfo.conditions.communityName"
                :placeholder="$t('shopCommunity.communityName')"
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select
                v-model="shopCommunityInfo.conditions.state"
                style="width:100%"
              >
                <el-option
                  :value="24002"
                  :label="$t('shopCommunity.auditPass')"
                />
                <el-option
                  :value="48004"
                  :label="$t('shopCommunity.auditNotPass')"
                />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="_queryAuditShopCommunitysMethod"
            >
              {{ $t('shopCommunity.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopCommunity.shopCommunity') }}</div>
      </div>
      <div class="">
        <el-table
          :data="shopCommunityInfo.shopCommunitys"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="communityId"
            :label="$t('shopCommunity.communityCode')"
            align="center"
          />
          <el-table-column
            prop="communityName"
            :label="$t('shopCommunity.communityName')"
            align="center"
          />
          <el-table-column
            prop="shopName"
            :label="$t('shopCommunity.shopName')"
            align="center"
          />
          <el-table-column
            prop="createTime"
            :label="$t('shopCommunity.settledTime')"
            align="center"
          />
          <el-table-column
            prop="startTime"
            :label="$t('shopCommunity.startTime')"
            align="center"
          />
          <el-table-column
            prop="endTime"
            :label="$t('shopCommunity.endTime')"
            align="center"
          />
          <el-table-column
            prop="stateName"
            :label="$t('shopCommunity.state')"
            align="center"
          />
          <el-table-column
            :label="$t('shopCommunity.operation')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="_openShopCommunityWithdrawModel(scope.row)"
              >
                {{ $t('shopCommunity.withdraw') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="shopCommunityInfo.conditions.page"
          :page-size="shopCommunityInfo.conditions.row"
          :total="shopCommunityInfo.total"
          layout="total, prev, pager, next"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <audit
      ref="audit"
      :call-back-listener="'auditShopCommunity'"
      :call-back-function="'notifyAudit'"
    />
    <shop-community-withdraw ref="shopCommunityWithdraw" />
  </div>
</template>

<script>
import { queryShopCommunity } from '@/api/admin/shopCommunityApi'
import Audit from '@/components/common/audit/Audit'
import ShopCommunityWithdraw from '@/components/admin/shopCommunityWithdraw/shopCommunityWithdraw'

export default {
  name: 'ShopCommunity',
  components: {
    Audit,
    ShopCommunityWithdraw
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      shopCommunityInfo: {
        shopCommunitys: [],
        total: 0,
        records: 1,
        conditions: {
          state: '24002',
          shopName: '',
          communityName: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAuditShopCommunitys(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listAuditShopCommunitys(page, rows) {
      this.shopCommunityInfo.conditions.page = page
      this.shopCommunityInfo.conditions.row = rows
      try {
        const res = await queryShopCommunity(this.shopCommunityInfo.conditions)
        this.shopCommunityInfo.total = res.total
        this.shopCommunityInfo.records = res.records
        this.shopCommunityInfo.shopCommunitys = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openShopCommunityWithdrawModel(shopCommunity) {
      this.$refs.shopCommunityWithdraw.open(shopCommunity)
    },
    _queryAuditShopCommunitysMethod() {
      this._listAuditShopCommunitys(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handlePageChange(currentPage) {
      this._listAuditShopCommunitys(currentPage, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  clear: both;
}
</style>